export default __webpack_public_path__ + "static/media/no-smoking.bbf5e68b.svg";